import { type Expect } from '@type-challenges/utils';
import { type FunctionComponent, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { type PickDeep } from 'type-fest';
import { authSlice } from '../../core/auth/auth.slice';
import {
  type RootState,
  type StrictSubsetOfRootState,
} from '../../core/root.state';
import { useSelector } from '../../hooks/useSelector';
import { AppRoute } from '../../routes';

export type RootPageProps = {
  children?: never;
};

export type RootPageState = PickDeep<RootState, 'auth.continueRoutePostLogin'>;

type CheckState = Expect<StrictSubsetOfRootState<RootPageState>>;

export const RootPage: FunctionComponent<RootPageProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state: RootPageState) => state.auth);

  const continueRoutePostLogin = useRef(auth.continueRoutePostLogin);

  useEffect(() => {
    if (continueRoutePostLogin.current) {
      void navigate(continueRoutePostLogin.current);
      dispatch(authSlice.actions.clearContinueRoutePostLogin());
    } else {
      void navigate(AppRoute['/chat']);
    }
  }, [dispatch, navigate]);

  return null;
};
